module.exports = __webpack_public_path__ + "img/contributionsOtherOn.1374c15a.svg";